import { render, staticRenderFns } from "./set-restrict-shipout.vue?vue&type=template&id=6924a1fe&scoped=true"
import script from "./set-restrict-shipout.vue?vue&type=script&lang=js"
export * from "./set-restrict-shipout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6924a1fe",
  null
  
)

export default component.exports